import { Avatar, Box, Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import check from "../assets/icons/check.svg";
import strings from "../helper/strings";
import { Benefit } from "../interfaces/products";
interface IncludedProductProps {
  benefits: Benefit[] | undefined;
}

function IncludedProduct(props: IncludedProductProps) {
  return (
    <Stack pt={2}>
      {props.benefits && props.benefits?.length > 0 && (
        <Typography align="center" sx={{ fontSize: { xs: 24, md: 48 } }}>
          {strings.main.whatIncludes}
        </Typography>
      )}

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignSelf: "center",
          px: 4.875,
          gap: 3,
          "& > :not(style)": {
            m: 1,
            width: { xs: "100%", md: 296 },
            height: 294,
            borderRadius: 4,
          },
        }}
      >
        {props.benefits?.map((item, index) => (
          <Grid
            key={index}
            container
            spacing={2}
            direction="column"
            alignItems="center"
            justifyContent="center"
            boxShadow="0px 45px 65px rgba(51, 51, 51, 0.15)"
          >
            <Grid item>
              <Avatar
                src={item.icon ? item.icon : check}
                alt="Remy Sharp"
                sx={{
                  "& .MuiAvatar-img": {
                    width: "auto",
                    height: "60%",
                  },
                  height: 68,
                  width: 68,
                }}
              />
            </Grid>
            <Grid item>
              <Typography
                align="center"
                sx={{
                  fontFamily: "FbCoherentiSans",
                  fontSize: 24,
                }}
              >
                {item.header}{" "}
              </Typography>
              <Typography
                align="center"
                sx={{
                  fontFamily: "FbCoherentiSans-light",
                  opacity: 0.45,
                  direction: "rtl",
                }}
                variant="body2"
              >
                {item.subHeader}{" "}
              </Typography>{" "}
            </Grid>
          </Grid>
        ))}
      </Box>
    </Stack>
  );
}

export default IncludedProduct;
